/**
 * Rutas privadas (panel, cuenta, back-office, flujos de auth) que nunca deben
 * indexarse. Se usa en el `head()` de la ruta raíz para emitir
 * `<meta name="robots" content="noindex, nofollow">` en el HTML servido,
 * además de las cabeceras `X-Robots-Tag` de `vercel.json` y del middleware.
 */
const PRIVATE_PREFIXES = [
  "/admin",
  "/panel",
  "/cuenta",
  "/dashboard",
  "/en/dashboard",
  "/mensajes",
  "/messages",
  "/onboarding",
  "/reset-password",
  "/auth",
  "/debug",
  "/checkout",
  "/api",
  "/.lovable",
];

export const isPrivatePath = (pathname: string): boolean => {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  return PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
};
